import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import CademiTable from "../../../components/apps/cademi/CademiTable";
import { useNavigate } from "react-router";

export default function Cademi() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Cademí"
                description="Cademí"
            />
            <PageBreadcrumb
                pageTitle="Cademí"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <CademiTable />
                </div>
            </div>
        </>
    );
}